<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import InputSwitch from 'primevue/inputswitch';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "content-add",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      v$: useVuelidate(),
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      title: "",
      description: "",
      can_skip: false,
      is_file: true,
      fileData: "",
      pdfData: "",     // optional PDF attached to a VIDEO content (split-screen)
      posterData: "",  // optional poster/thumbnail for a VIDEO content
      link: "",
      formSending: false,
      lesson: null,
      lessons: [],
      unit: null,
      units: [],
      branch: null,
      branches: [],
      type: null, // will be set below
      typeOptions: [
        {
          label: 'ملف',
          value: 'pdf'
        },
        {
          label: 'فيديو',
          value: 'video'
        },
        {
          label: 'صوت',
          value: 'audio'
        },
        // {
        //   label: 'إمتحان',
        //   value: 'exam'
        // }
      ]
    };
  },
  components: {
    Breadcrumb,
    InputText,
    Dropdown,
    InputSwitch
  },
  validations() {
    return {
      title: { required },
      // description: { required },
      // can_skip: { required },
      type: { required },
      is_file: { required },
    };
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope ? `/courses/${this.courseId}/contents` : `/${this.gradeSlug}/content`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [...base, { name: "المحتوى", path: this.basePath }, { name: "إضافة محتوى", path: `${this.basePath}/add` }];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "المحتوى", path: `/${this.gradeSlug}/content` },
        { name: "إضافة محتوى", path: `/${this.gradeSlug}/content/add` },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
  },
  methods: {
    onFileChange(event) {
      this.fileData = event.target.files[0];
    },
    onPdfChange(event) {
      this.pdfData = event.target.files[0];
    },
    onPosterChange(event) {
      this.posterData = event.target.files[0];
    },
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('title', this.title);
        formData.append('description', this.description);
        // formData.append('can_skip', this.can_skip ? 1 : 0);
        formData.append('lesson_id', this.lesson?.id ?? this.unit?.id ?? this.branch?.id);
        formData.append('type', this.type?.value);
        formData.append('is_file', this.is_file ? 1 : 0);
        if (this.is_file && this.fileData) {
          formData.append('file', this.fileData);
        }
        if (!this.is_file && this.link) {
          formData.append('link', this.link);
        }
        // Optional PDF attached to a video content (split-screen). Sent regardless
        // of is_file (the video may be an uploaded file OR an external link).
        if (this.type?.value === 'video' && this.pdfData) {
          formData.append('pdf_file', this.pdfData);
        }
        // Optional poster/thumbnail — same rule: only meaningful for video content.
        if (this.type?.value === 'video' && this.posterData) {
          formData.append('poster', this.posterData);
        }
        this.formSending = true;
        axios
            .post('/contents', formData)
            .then(() => {
              this.formSending = false;
              this.resetForm();
              Swal.fire({ position: "center", icon: "success", title: "تم الاضافه بنجاح" });
            })
            .catch((error) => {
              this.formSending = false;
              Swal.fire({ position: "center", icon: "error", title: error.response.data.message });
            });
      }
    },
    resetForm() {
      this.v$.$reset();
      this.title = "";
      this.description = "";
      // this.can_skip = false;
      this.type = null;
      this.is_file = true;
      this.fileData = "";
      this.pdfData = "";
      this.posterData = "";
      this.link = "";
      this.lesson = null;
    },
    fetchBranch() {
      const params = this.isCourseScope
          ? { type: 1, course_id: this.courseId }
          : { type: 1, academic_year_id: this.gradeId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.branches = response.data.data; })
          .catch(() => {});
    },
    fetchUnits() {
      const branchId = this.branch?.id;
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId, parent_id: branchId }
          : { type: 2, academic_year_id: this.gradeId, parent_id: branchId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.units = response.data.data; })
          .catch(() => {});
    },
    fetchLessons() {
      const unitId = this.unit?.id;
      const params = this.isCourseScope
          ? { type: 3, course_id: this.courseId, parent_id: unitId }
          : { type: 3, academic_year_id: this.gradeId, parent_id: unitId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.lessons = response.data.data; })
          .catch(() => {});
    },

    customLabelBranch(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelUnit(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelLesson(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    this.fetchBranch();
    if (!this.type && this.typeOptions.length) {
      this.type = this.typeOptions[0];
    }
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-cloud-upload"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة محتوى</h1>
        <p class="form-page-header__subtitle">رفع ملفات أو روابط للطلاب</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <!-- Content type -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-th-large"></i></div>
            <span class="form-card__title">نوع المحتوى <span style="color:var(--color-danger);font-size:0.75rem;">*</span></span>
          </div>
          <div class="form-card__body">
            <div class="type-selector">
              <label
                v-for="option in typeOptions"
                :key="option.value"
                :class="['type-selector__item', { active: type?.value === option.value }]"
              >
                <input type="radio" v-model="type" :value="option" class="d-none" />
                <i :class="`pi ${option.value === 'pdf' ? 'pi-file-pdf' : option.value === 'video' ? 'pi-video' : 'pi-volume-up'}`"></i>
                {{ option.label }}
              </label>
            </div>
            <span class="field-error mt-2" v-if="v$.type.$error">
              <i class="pi pi-exclamation-circle"></i> برجاء اختيار نوع المحتوى
            </span>
          </div>
        </div>

        <!-- Location hierarchy -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-sitemap"></i></div>
            <span class="form-card__title">الموقع في المنهج</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="branch">الفرع</label>
                  <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-100" @update:model-value="fetchUnits" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="unit">الوحدة</label>
                  <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحدة" class="w-100" @update:model-value="fetchLessons" />
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="lesson">الدرس</label>
                  <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Content details -->
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-pencil"></i></div>
            <span class="form-card__title">تفاصيل المحتوى</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="title">
                    اسم المحتوى <span class="required">*</span>
                  </label>
                  <InputText id="title" v-model="title" placeholder="أدخل اسم المحتوى" class="w-100" />
                  <span class="field-error" v-if="v$.title.$error">
                    <i class="pi pi-exclamation-circle"></i> برجاء ادخال اسم المحتوى
                  </span>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="description">
                    الوصف <span class="optional">اختياري</span>
                  </label>
                  <InputText id="description" v-model="description" placeholder="أدخل وصف المحتوى" class="w-100" />
                </div>
              </div>
            </div>

            <!-- Source toggle -->
            <div class="source-toggle mt-4">
              <i class="pi pi-file" style="color: var(--text-secondary);"></i>
              <span class="source-toggle__label">رفع ملف</span>
              <InputSwitch id="isFile" v-model="is_file" />
              <span class="source-toggle__hint">{{ is_file ? 'سيتم رفع ملف' : 'سيتم إدخال رابط خارجي' }}</span>
            </div>

            <!-- File upload -->
            <div class="mt-4" v-if="is_file">
              <label class="field-label">الملف</label>
              <div :class="['upload-zone', { 'upload-zone--has-file': fileData }]">
                <div class="upload-zone__icon">
                  <i :class="`pi ${fileData ? 'pi-check' : 'pi-cloud-upload'}`"></i>
                </div>
                <p class="upload-zone__label">{{ fileData ? fileData.name : 'اضغط لاختيار ملف' }}</p>
                <p class="upload-zone__hint" v-if="!fileData">PDF, MP4, MP3 وغيرها</p>
                <input type="file" @change="onFileChange" accept=".pdf,.mp4,.mp3,.avi,.mov" />
              </div>
            </div>

            <!-- URL input -->
            <div class="mt-4" v-else>
              <div class="form-field">
                <label class="field-label" for="link">رابط المحتوى</label>
                <InputText id="link" v-model="link" placeholder="https://..." class="w-100" dir="ltr" />
              </div>
            </div>

            <!-- Optional PDF attachment — ONLY for video content (split-screen video + PDF) -->
            <div class="mt-4" v-if="type?.value === 'video'">
              <label class="field-label">ملف PDF مرفق <span class="optional">اختياري</span></label>
              <p class="upload-zone__hint mb-2">يظهر أسفل الفيديو للطالب. اتركه فارغًا لعرض الفيديو فقط.</p>
              <div :class="['upload-zone', { 'upload-zone--has-file': pdfData }]">
                <div class="upload-zone__icon">
                  <i :class="`pi ${pdfData ? 'pi-check' : 'pi-file-pdf'}`"></i>
                </div>
                <p class="upload-zone__label">{{ pdfData ? pdfData.name : 'اضغط لاختيار ملف PDF' }}</p>
                <p class="upload-zone__hint" v-if="!pdfData">PDF فقط</p>
                <input type="file" @change="onPdfChange" accept="application/pdf,.pdf" />
              </div>
            </div>

            <!-- Video poster/thumbnail — ONLY for video content. Shown by the player
                 before playback starts and whenever paused, instead of a random frame
                 (or, for the YouTube-backed players, instead of the auto YouTube thumbnail). -->
            <div class="mt-4" v-if="type?.value === 'video'">
              <label class="field-label">بوستر الفيديو <span class="optional">اختياري</span></label>
              <p class="upload-zone__hint mb-2">يظهر قبل تشغيل الفيديو وأثناء الإيقاف المؤقت. اتركه فارغًا لاستخدام السلوك الافتراضي.</p>
              <div :class="['upload-zone', { 'upload-zone--has-file': posterData }]">
                <div class="upload-zone__icon">
                  <i :class="`pi ${posterData ? 'pi-check' : 'pi-image'}`"></i>
                </div>
                <p class="upload-zone__label">{{ posterData ? posterData.name : 'اضغط لاختيار صورة' }}</p>
                <p class="upload-zone__hint" v-if="!posterData">JPG, PNG, WebP</p>
                <input type="file" @change="onPosterChange" accept="image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp" />
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" :disabled="formSending">
            <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
            <i class="pi pi-check" v-else></i>
            {{ formSending ? 'جاري الإرسال...' : 'حفظ المحتوى' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>